<template>
  <div v-if="content" class="complex-card">
    <img :src="content.img" :alt="content.img">
    <div class="text">
      <vue-markdown>{{content.text}}</vue-markdown>
    </div>
  </div>
</template>

<script>
  import VueMarkdown from "vue-markdown";
  export default {
    props: {
      content: null
    },
    components: {
      VueMarkdown
    },
    data() {
      return {};
    },
    mounted() {
    },
    methods: {}
  };
</script>

<style lang="scss">
.complex-card {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap:30px;
  width:$content-width;
  max-width:$max-width;
  margin:0 auto;
  img {

  }
  .text {
    line-height:1.15;
    h3 {
      font-size:24px;
      margin-bottom:10px;
    }
    ul {
      list-style: disc;
      margin-left:30px;
    }
    p, li {
      font-weight:400;
      font-size:20px;
      margin-bottom:10px;
    }
  }
}
  @media screen and (max-width:1000px) {
    .complex-card {
      display: block;
      img {
        margin-bottom:20px;
      }
    }
  }
</style>
